import { render, staticRenderFns } from "./VasionUpload.vue?vue&type=template&id=46d0c8e3&scoped=true&"
import script from "./VasionUpload.vue?vue&type=script&lang=js&"
export * from "./VasionUpload.vue?vue&type=script&lang=js&"
import style0 from "./VasionUpload.vue?vue&type=style&index=0&id=46d0c8e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d0c8e3",
  null
  
)

export default component.exports